import { render, staticRenderFns } from "./auditPayContract.vue?vue&type=template&id=b70a608e&scoped=true"
import script from "./auditPayContract.vue?vue&type=script&lang=js"
export * from "./auditPayContract.vue?vue&type=script&lang=js"
import style0 from "./auditPayContract.vue?vue&type=style&index=0&id=b70a608e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70a608e",
  null
  
)

export default component.exports